export const Role = {
  Administrator: "Administrator",
  Developer: "Developer",
  Analyst: "Analyst",
  Operator: "Operator",
  Customer: "Customer",
  CustomerOperator: "CustomerOperator",
} as const;

export type Role = (typeof Role)[keyof typeof Role];

export const ALL_ROLES = Object.values(Role) as Role[];
